import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import style from "./Reports.module.scss";
import PropTypes from "prop-types";
import moment from "moment";

function ReportsTable({ reports }) {
  return (
    <TableContainer className={style.tableContainer} component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead style={{ backgroundColor: "#2c6d7a" }}>
          <TableRow>
            <TableCell className={style.tableHeader}>Nr.</TableCell>
            <TableCell className={style.tableHeader}>Name</TableCell>
            <TableCell className={style.tableHeader}>CNP/CIF</TableCell>
            <TableCell className={style.tableHeader}>Adresă</TableCell>
            <TableCell className={style.tableHeader}>Tip colectare</TableCell>
            <TableCell className={style.tableHeader}>Tip evacuare</TableCell>
            <TableCell className={style.tableHeader}>Data</TableCell>
            <TableCell className={style.tableHeader}>
              Validat/Nevalidat
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reports
            ? reports.map((report) => {
                return (
                  <>
                    <TableRow key={report.index}>
                      <TableCell className={style.tableRow}>
                        {report.index}
                      </TableCell>
                      <TableCell className={style.tableRow}>
                        {report.name}
                      </TableCell>
                      <TableCell className={style.tableRow}>
                        {report.cnp_cif}
                      </TableCell>
                      <TableCell className={style.tableRow}>
                        {report.fullAddress}
                      </TableCell>

                      <TableCell className={style.tableRow}>
                        {report.collectionType}
                      </TableCell>
                      <TableCell className={style.tableRow}>
                        {report.evacuationType}
                      </TableCell>
                      <TableCell className={style.tableRow}>
                        {moment(report.date).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell className={style.tableRow}>
                        {report.validated}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })
            : ""}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ReportsTable;

ReportsTable.propTypes = {
  reports: PropTypes.object,
};
